import React from "react";
import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Values from "./components/Values";
import Services from "./components/Services";
import Reputation from "./components/Reputation";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <Values />
        <Services />
        <Reputation />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
